import {
  createTRPCReact, httpBatchLink,
  splitLink,
  unstable_httpSubscriptionLink
} from '@trpc/react-query';
import { type AppRouter } from './router';

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
  links: [
    splitLink({
      // when condition is true, use normal request
      condition: (op) => op.type === 'subscription',
      true: unstable_httpSubscriptionLink({
        url: `/trpc/admin`
      }),
      false: httpBatchLink({
        url: `/trpc/admin`
      })
    })
  ]
});

/*

   (runtime) => {
      // initialize the different links for different targets
      const servers = {
        admin: httpBatchLink({ url: '/trpc/admin' })(runtime)
      };
      return (ctx) => {
        const { op } = ctx;
        // split the path by `.` as the first part will signify the server target name
        const pathParts = op.path.split('.');

        // first part of the query should be `server1` or `server2`
        const serverName = pathParts.shift() as keyof typeof servers;

        // combine the rest of the parts of the paths
        // -- this is what we're actually calling the target server with
        const path = pathParts.join('.');
        // console.log(`> calling ${serverName} on path ${path}`, {
        //   input: op.input
        // });

        const link = servers[serverName];

        return link({
          ...ctx,
          op: {
            ...op,
            path
          }
        });
      };
    }

*/
